import { Box, Button, Menu, MenuItem } from '@mui/material';
import { ErrorsStatus } from 'components/ErrorsCorrections/ErrorsTable/constants';
import { errorsTableStructure } from 'components/ErrorsCorrections/ErrorsTable/errors-table-structure';
import { TTableStructure } from 'components/ErrorsCorrections/ErrorsTable/types';
import { FC, MouseEvent, SyntheticEvent, useState } from 'react';

export type TStatusMenuProps = {
	status: ErrorsStatus;
	size: 'xs' | 'sm' | 'md' | 'lg' | undefined;
	onClick: (status: ErrorsStatus) => void;
};
export const StatusMenu: FC<TStatusMenuProps> = ({ status, onClick, size = 'sm' }) => {
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const tableStructure = errorsTableStructure() as TTableStructure[];

	const openStatusMenu = Boolean(anchorEl);
	const handleClickStatusMenu = (e: MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(e.currentTarget);
		e.stopPropagation();
	};
	const handleCloseStatusMenu = (e: SyntheticEvent) => {
		setAnchorEl(null);
		e.stopPropagation();
	};

	const handleSelectStatus = (stat: ErrorsStatus, e: SyntheticEvent) => {
		setAnchorEl(null);
		onClick(stat);
		e.stopPropagation();
	};

	return (
		<Box
			sx={{
				p: 0,
				m: 0,
				position: 'relative',
				right: '0',
				top: '0',
				// width: '100%',
				// height: '100%',
			}}
		>
			<Button
				size="small"
				variant="contained"
				color={
					status === ErrorsStatus.FIXED
						? 'success'
						: status === ErrorsStatus.NEW
							? 'warning'
							: status === ErrorsStatus.CONTACTING_CLIENT
								? 'primary'
								: status === ErrorsStatus.WORKING_ON_IT
									? 'info'
									: // : status === ErrorsStatus.NOT_FIXED
										// 	? 'prymary'
										'inherit'
				}
				sx={{
					m: 0,
					p: ' 1px 8px',
					fontSize:
						size === 'xs' ? '.75rem' : size === 'sm' ? '0.9rem' : size === 'md' ? '1rem' : '1.2rem',
					width: 'content-fit',
					whiteSpace: 'nowrap',
					// bgcolor:
					// 	status === ErrorsStatus.FIXED
					// 		? 'success.light'
					// 		: status === ErrorsStatus.NEW
					// 			? 'warning.light'
					// 			: status === ErrorsStatus.CONTACTING_CLIENT
					// 				? 'primary.light'
					// 				: status === ErrorsStatus.WORKING_ON_IT
					// 					? 'info.light'
					// 					: '#c5c5c5',
					// color: '#00000090',
					cursor: 'pointer',
					fontWeight: '600',
					textTransform: 'none',
					borderRadius: '14px!important',
					// '&:hover': {
					// 	bgcolor:
					// 		status === ErrorsStatus.FIXED
					// 			? 'success.main'
					// 			: status === ErrorsStatus.NEW
					// 				? 'warning.main'
					// 				: status === ErrorsStatus.CONTACTING_CLIENT
					// 					? 'primary.main'
					// 					: status === ErrorsStatus.WORKING_ON_IT
					// 						? 'info.main'
					// 						: '#aaa',
					// 	color: '#00000090',
					// },
				}}
				onClick={handleClickStatusMenu}
			>
				{status ?? 'Unknown Status'}
				{status === ('' as ErrorsStatus) ? 'Set Status' : ''}
			</Button>
			<Menu
				anchorEl={anchorEl}
				open={openStatusMenu}
				onClose={handleCloseStatusMenu}
				MenuListProps={{
					'aria-labelledby': 'basic-button',
				}}
				sx={{
					'& .MuiMenu-paper': {
						borderRadius: '12px',
					},
				}}
			>
				{tableStructure
					?.find((i) => i.selector === 'status')
					?.filter?.map?.((stat1, index) => {
						// if (!item) return null;
						const stat = stat1 as unknown as ErrorsStatus[];
						return (
							<MenuItem
								key={stat[0]}
								// onClick={() => handleSelectFilter(index)}
								color="primary"
								sx={{ color: 'primary.main', fontWeight: 'bold' }}
							>
								<Button
									size="small"
									variant="contained"
									color={
										stat[1] === ErrorsStatus.FIXED
											? 'success'
											: stat[1] === ErrorsStatus.NEW
												? 'warning'
												: stat[1] === ErrorsStatus.CONTACTING_CLIENT
													? 'primary'
													: stat[1] === ErrorsStatus.WORKING_ON_IT
														? 'info'
														: // : stat[1] === ErrorsStatus.NOT_FIXED
															// 	? 'secondary'
															'primary'
									}
									sx={{
										p: '2px 10px',
										m: 0,
										fontSize:
											size === 'xs' ? '.7rem' : size === 'sm' ? '0.9rem' : size === 'md' ? 20 : 48,
										height: '20px',
										// bgcolor:
										// 	stat[1] === ErrorsStatus.FIXED
										// 		? 'success.light'
										// 		: stat[1] === ErrorsStatus.NEW
										// 			? 'warning.light'
										// 			: stat[1] === ErrorsStatus.CONTACTING_CLIENT
										// 				? 'primary.light'
										// 				: 'info.light',
										// color: '#00000090',
										cursor: 'pointer',
										fontWeight: '600',
										textTransform: 'none',
										borderRadius: '20px!important',
										// '&:hover': {
										// 	bgcolor:
										// 		stat[1] === ErrorsStatus.FIXED
										// 			? 'success.main'
										// 			: stat[1] === ErrorsStatus.NEW
										// 				? 'warning.main'
										// 				: stat[1] === ErrorsStatus.CONTACTING_CLIENT
										// 					? 'primary.main'
										// 					: 'info.main',
										// 	color: '#000000',
										// },
									}}
									onClick={(e) => handleSelectStatus(stat[0], e)}
								>
									{stat[1]}
								</Button>
							</MenuItem>
						);
					}) ?? null}
			</Menu>
		</Box>
	);
};
